import React, { useRef, useState } from "react";

import Tooltip from "@mui/material/Tooltip";

import { Backspace, Check, Edit } from "@mui/icons-material";
import { formatValuta } from "../../utils";

import Button from "../CustomButtons/Button";
import NumberInput from "../CustomInput/NumberInput";

import { withStyles } from "tss-react/mui";
import DistancecostSChemeStyle from "./DistanceCostSchemeStyle";
import TranslationWrapper from "../TranslationWrapper/TranslationWrapper";

function DistanceSlot(props) {
  const [startDistance, setStartDistance] = useState(props.startDistance);
  const [stopDistance, setStopDistance] = useState(props.stopDistance);
  const [price, setPrice] = useState(props.price);
  const [editing, setEditing] = useState(props.editing);
  const id = useRef(props.id);

  const getData = () => {
    return {
      startDistance: parseFloat(startDistance),
      stopDistance: parseFloat(stopDistance),
      price: parseFloat(price),
      id: id.current ?? String(Math.random()),
    };
  };

  const save = () => {
    if (props.isNewSlot) {
      props.handleDataChange(props.arrPlace, "ADD", getData());
    } else {
      props.handleDataChange(props.arrPlace, "UPDATE", getData());
    }
    setEditing(false);
  };

  const removeItem = () => {
    props.handleDataChange(props.arrPlace, "DELETE");
  };
  const { classes } = props;

  return (
    <tr>
      {!editing
        ? [
            <td>
              {startDistance} <TranslationWrapper tDefault={"km"} tKey={"global.km"} />
            </td>,
            <td>
              {stopDistance} <TranslationWrapper tDefault={"km"} tKey={"global.km"} />
            </td>,
            <td>{formatValuta(price, props.currency)}</td>,
            <td>
              <Tooltip
                classes={{ tooltip: classes.tooltip }}
                placement={"bottom"}
                title={<TranslationWrapper tDefault={"Verwijderen"} tKey={"global.button.verwijderen"} />}
              >
                <Button className={classes.actionButton} color={"danger"} onClick={removeItem} simple>
                  <Backspace className={classes.icon} />
                </Button>
              </Tooltip>
              <Tooltip
                classes={{ tooltip: classes.tooltip }}
                placement={"bottom"}
                title={<TranslationWrapper tDefault={"Edit"} tKey={"global.jamezzTable.edit"} />}
              >
                <Button
                  className={classes.actionButton}
                  color={"success"}
                  onClick={() => {
                    setEditing(!editing);
                  }}
                  simple
                >
                  <Edit className={classes.icon} />
                </Button>
              </Tooltip>
            </td>,
          ]
        : [
            <td>
              <NumberInput
                decimalen={2}
                onChange={(e) => setStartDistance(e.value)}
                suffix={" km"}
                value={startDistance}
              />
            </td>,
            <td>
              <NumberInput
                decimalen={2}
                onChange={(e) => setStopDistance(e.value)}
                suffix={" km"}
                value={stopDistance}
              />
            </td>,
            <td>
              <NumberInput
                currency={props.currency}
                onChange={(e) => setPrice(e.value)}
                type={"valuta"}
                value={price}
              />
            </td>,
            <td>
              <Tooltip
                classes={{ tooltip: classes.tooltip }}
                placement={"bottom"}
                title={<TranslationWrapper tDefault={"Opslaan"} tKey={"global.tooltip.opslaan"} />}
              >
                <Button
                  className={classes.actionButton}
                  color="success"
                  simple
                  onClick={save}
                  // disabled={!canSave()}
                >
                  <Check className={classes.icon} />
                </Button>
              </Tooltip>
            </td>,
          ]}
    </tr>
  );
}

export default withStyles(DistanceSlot, DistancecostSChemeStyle);
